import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import { createLibraryAsana } from 'services/library/createLibraryAsana';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const CreateAsanaLibrary = ({ open, onClose }) => {
  const [asanaName, setAsanaName] = useState('');
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  // Replace 'coachId' with the actual key used in your localStorage
  const coachId = localStorage.getItem('userid');

  const resetForm = () => {
    setAsanaName('');
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: createLibraryAsana,
    onSuccess: (response) => {
      if (response?.data?.status) {
        toast.success(response.data.message || 'Asana Created Successfully');
        resetForm();
        queryClient.invalidateQueries(['allPoses']);
        if (onClose) onClose();
        navigate('/library', { replace: true });
      } else {
        toast.error('Unexpected response format');
      }
    },
    onError: (error) => {
      toast.error('Failed to create pose: ' + (error.message || 'Unknown error'));
      console.error('Failed to create pose:', error);
    }
  });

  const handleCreate = () => {
    const newAsana = {
      asanaName: asanaName,
      coachId: Number(coachId)
    };
    mutate(newAsana);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pb: 2 }}>Create New Asana</DialogTitle>
      <DialogContent>
        <TextField
          label="Asana Name"
          variant="outlined"
          value={asanaName}
          onChange={(e) => setAsanaName(e.target.value)}
          sx={{ mb: 2, width: '100%' }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="secondary">
          Cancel
        </Button>
        <Button variant="contained" onClick={handleCreate} disabled={isLoading}>
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateAsanaLibrary;
